import { Link } from "react-router-dom";
import { MapPin, Mail, Heart, Instagram } from "lucide-react";
import { NAV, EVENT, LINKS, LOGO, AO_BADGE } from "../lib/site";

export const Footer = () => (
  <footer className="relative z-10 bg-forest text-cream/90" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-2.5">
          <span className="h-14 w-14 shrink-0">
            <img src={LOGO} alt="Turkey Trot logo" className="h-14 w-14 object-contain" />
          </span>
          <span className="font-display text-2xl font-semibold text-cream leading-tight">Grimsby On The Lake<br />Turkey Trot</span>
        </div>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-cream/70">
          A family-friendly charity run on the shore of Lake Ontario. Every stride supports {EVENT.charity}.
        </p>
        <p className="mt-4 flex items-start gap-2 text-sm text-cream/80">
          <MapPin size={16} className="mt-0.5 shrink-0 text-ochre" />
          {EVENT.location.name}, {EVENT.location.address}
        </p>
        <div className="mt-6 flex items-center gap-3">
          <img src={AO_BADGE} alt="Athletics Ontario Sanctioned Race 2026" className="w-16 h-16 shrink-0" data-testid="ao-badge-footer" />
          <p className="text-sm text-cream/80 max-w-[200px]">Proud Athletics Ontario Sanctioned Race for 2026.</p>
        </div>
      </div>

      <div className="md:col-span-4">
        <h4 className="font-accent text-2xl text-ochre">Explore</h4>
        <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} className="text-cream/75 hover:text-white transition-colors duration-200">
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-3">
        <h4 className="font-accent text-2xl text-ochre">Join In</h4>
        <div className="mt-4 flex flex-col gap-3">
          <a href={LINKS.register} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-terracotta text-white text-sm font-semibold hover:bg-sienna transition-colors duration-200">
            Register Now
          </a>
          <Link to="/sponsor-donation" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full border border-cream/30 text-cream text-sm font-semibold hover:bg-cream/10 transition-colors duration-200">
            <Heart size={15} /> Donate
          </Link>
          <Link to="/contact" className="inline-flex items-center gap-2 text-sm text-cream/75 hover:text-white transition-colors duration-200">
            <Mail size={15} /> Contact us
          </Link>
          <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-cream/75 hover:text-white transition-colors duration-200" data-testid="footer-instagram-link">
            <Instagram size={15} /> @grimsbyturkeytrot
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-cream/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-cream/60">
        <p>© {new Date().getFullYear()} Grimsby On The Lake Turkey Trot. All rights reserved.</p>
        <p>Proudly supporting {EVENT.charity}.</p>
      </div>
    </div>
  </footer>
);
